import type { FC } from "react";
import React from "react";
import loadable from "@loadable/component";
import type { ModalProps } from "../../../../../shared-components/css-modules/toyota/organisms/Modal";
import Modal from "../../../../../shared-components/css-modules/toyota/organisms/Modal";
import { COMPONENT_CAR_CONFIG } from "../../../../../../../shared-logic/server/components";

const IntegratedTradeInAem = loadable(async () => {
    const component = await import(
        /* webpackChunkName: "integrated-tradein-aem-aph-toyota" */
        "../../../../../../../tradein/components/toyota/IntegratedTradeInAem"
    );
    return component.default;
});

const IntegratedTradeInAemAphModal: FC<ModalProps> = (props) => {
    const { open, onRequestClose } = props;

    return (
        <Modal open={open} onRequestClose={onRequestClose}>
            {/* Currently the content of all modals is rendered even if the modal isn't opened. Rendering the IntegratedTradeInAem will initialise Trade-in.*/}
            {/* To avoid this happening we added this check, so Trade-in is initialised when the user tries to open the modal only.*/}
            {open && <IntegratedTradeInAem parentComponent={COMPONENT_CAR_CONFIG} />}
        </Modal>
    );
};

export default IntegratedTradeInAemAphModal;
